import { Box, Button, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { getSvg } from '@/utils/get-svg';

interface FreeCourseDialogProps {
  onClose: () => void;
}

export const FreeCourseDialog = ({ onClose }: FreeCourseDialogProps) => {
  return (
    <BaseDialog
      open
      onClose={onClose}
      title="Não é possível pedir reembolso para este curso."
      icon={
        <Box
          component="img"
          src={getSvg('no_available_balance.svg')}
          sx={{ width: 128 }}
        />
      }
      actionsComponent={
        <Button variant="contained" onClick={onClose}>
          Fechar
        </Button>
      }
    >
      <Typography>
        O curso que você selecionou não tem custo e, por isso, não é possível
        pedir reembolso para ele.
      </Typography>
    </BaseDialog>
  );
};
